<template>
    <div
        class="max-w-sm border md:rounded overflow-hidden bg-white m-auto md:shadow-lg mb-8 mt-0 property-card"
        :class="myclass"
    >
        <img
            class="w-full"
            :src="image"
            :alt="title"
            v-if="image.length > 0"
            @click="goImageLink"
        />
        <div class="px-6 py-4">
            <div
                class="font-bold text-xl mb-2 text-gray-800"
                v-text="title"
            ></div>
        </div>
        <div class="px-6 py-4" v-if="hasAny">
            <span
                class="inline-block bg-gray-200 px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 publish-status"
                v-text="publishStatus"
                v-if="hasPublish"
            ></span>
            <span
                class="inline-block bg-gray-200 px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 score"
                v-text="score"
                v-if="hasScore"
            ></span>
            <span
                class="inline-block bg-gray-200 px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 views"
                v-text="Views"
                v-if="hasViews"
            ></span>
            <span
                class="inline-block bg-gray-200 px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 signups"
                v-text="Signups"
                v-if="hasSignups"
            ></span>
        </div>
        <div class="px-6 pb-4">
            <a
                :href="link1"
                class="button is-primary"
                v-text="buttonlabel1"
                v-if="showLabel1"
            ></a>
            <a
                :href="link2"
                class="button is-primary ml-2"
                v-text="buttonlabel2"
                v-if="showLabel2"
            ></a>
        </div>
    </div>
</template>
<script>
var isNullOrEmpty = require("is-null-or-empty");
import { mapState, mapMutations, mapGetters } from "vuex";
var isNullOrEmpty = require("is-null-or-empty");
export default {
    props: [
        "publishStatus",
        "title",
        "token",
        "score",
        "views",
        "signups",
        "image",
        "link1",
        "buttonlabel1",
        "link2",
        "buttonlabel2",
        "myclass",
        "imagelink"
    ],
    methods: {
        isScore() {
            return typeof this.$props.score !== "undefined" &&
                this.$props.score !== null &&
                this.$props.score > 0
                ? true
                : false;
        },
        isViews() {
            return typeof this.$props.views !== "undefined" &&
                this.$props.views !== null &&
                this.$props.views > 0
                ? true
                : false;
        },
        isSignups() {
            return typeof this.$props.signups !== "undefined" &&
                this.$props.signups !== null &&
                this.$props.signups > 0
                ? true
                : false;
        },
        isPublish() {
            return typeof this.$props.publishStatus !== "undefined" &&
                this.$props.publishStatus !== null &&
                this.$props.publishStatus.length > 0
                ? true
                : false;
        },
        goImageLink() {
            if (!isNullOrEmpty(this.$props.imagelink)) {
                document.location.href = this.$props.imagelink;
            }
        }
    },
    computed: {
        showLabel1() {
            return !isNullOrEmpty(this.$props.buttonlabel1);
        },
        showLabel2() {
            return !isNullOrEmpty(this.$props.buttonlabel2);
        },
        Views() {
            return parseInt(this.$props.views) > 1
                ? this.$props.views + " Views"
                : this.$props.views + " View";
        },
        Signups() {
            return parseInt(this.$props.signups) > 1
                ? this.$props.signups + " Sign ups"
                : this.$props.signups + " Sign up";
        },
        hasScore() {
            return this.isScore();
        },
        hasViews() {
            return this.isViews();
        },
        hasSignups() {
            return this.isSignups();
        },
        hasPublish() {
            return this.isPublish();
        },
        hasAny() {
            return (
                this.isPublish() ||
                this.isSignups() ||
                this.isViews() ||
                this.isScore()
            );
        }
    }
};
</script>
